import { createIcon } from "@chakra-ui/react";

const PersonIcon = createIcon({
  displayName: "PersonIcon",
  viewBox: "0 0 24 24",
  path: (
    <>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16 8C16 10.2091 14.2091 12 12 12C9.79086 12 8 10.2091 8 8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8ZM14.5 8C14.5 9.38071 13.3807 10.5 12 10.5C10.6193 10.5 9.5 9.38071 9.5 8C9.5 6.61929 10.6193 5.5 12 5.5C13.3807 5.5 14.5 6.61929 14.5 8Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.2857 14H8.71429C5.55837 14 3 16.5584 3 19.7143C3 19.8721 3.12792 20 3.28572 20H20.7143C20.8721 20 21 19.8721 21 19.7143C21 16.5584 18.4416 14 15.2857 14ZM19.3224 18.5C18.8011 16.7645 17.1911 15.5 15.2857 15.5H8.71429C6.80893 15.5 5.19891 16.7645 4.67757 18.5H19.3224Z"
        fill="currentColor"
      />
    </>
  ),
});

export default PersonIcon;
